<template>
    <auth-layout :isPlain="true" :isProgressBarHidden="true">
        <template #default>
            <common-content-wrapper v-if="!isIpVerification" width="small">
                <common-page-header :heading="pageHeading" :content="$t('pages.auth.login.description')"></common-page-header>
            </common-content-wrapper>

            <template v-if="infoMessage">
                <common-content-wrapper width="small">
                    <common-message :type="commonMessageType(infoMessage.type)">
                        <p>{{ infoMessage.content }}</p>
                    </common-message>
                </common-content-wrapper>
            </template>

            <common-content-wrapper width="small">
                <login-form
                    :isDisabled="areFieldsDisabled"
                    @sent="afterSent()"
                    @form-submitted="formSubmitted"
                    @ip-verification-changed="isIpVerification = $event"
                ></login-form>
            </common-content-wrapper>
            <common-content-wrapper v-if="isMobileLarge && !isIpVerification" width="small">
                <div class="login-signup-mobile">
                    <common-divider>
                        <p>{{ $t('pages.auth.signup.steps.register.description.or') }}</p>
                    </common-divider>

                    <common-buttons>
                        <common-button
                            :label="$t('forms.auth.register.microcopy.signup')"
                            type="secondary"
                            :isDisabled="areFieldsDisabled"
                            @click="goToRegistration()"
                        ></common-button>
                    </common-buttons>
                </div>
            </common-content-wrapper>
        </template>

        <template #aside>
            <template v-if="!isMobileLarge && !isIpVerification">
                <div class="auth-layout__aside--get-started">
                    <p>
                        {{ $t('pages.auth.login.dont_have_account') }}
                    </p>
                    <p>
                        {{ $t('pages.auth.login.create_one_free') }}
                    </p>
                </div>

                <common-button
                    :label="$t('pages.auth.login.get_started')"
                    type="secondary"
                    :isDisabled="areFieldsDisabled"
                    size="small"
                    @click="goToRegistration()"
                ></common-button>
            </template>
        </template>
    </auth-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import LoginForm from 'components/forms/AuthLoginForm'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import GoogleAnalyticsService from 'services/GoogleAnalyticsService'

    export default {
        mixins: [PageWithTitleMixin, ScreenSizeDetectionMixin],

        components: {
            AuthLayout,
            LoginForm,
        },

        data() {
            return {
                areFieldsDisabled: undefined,
                isIpVerification: false,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.login.title')
            },

            pageHeading() {
                return this.isMobileLarge ? this.$t('pages.auth.login.heading_mobile') : this.$t('pages.auth.login.heading')
            },

            infoMessage() {
                const type = this.$route.query['verified']

                if (['success', 'error', 'email_sent'].includes(type)) {
                    return { type, content: this.$t(`pages.auth.login.verified.${type}`) }
                }

                return false
            },
        },

        methods: {
            afterSent() {
                this.areFieldsDisabled = true
                this.$router.push(this.$route.query.redirect || { name: 'index' })
            },

            goToRegistration() {
                GoogleAnalyticsService.event('cta_clicked')
                this.areFieldsDisabled = true
                this.$router.push({ name: 'auth.signup.register' })
            },

            commonMessageType(type) {
                if (type === 'email_sent') {
                    return 'success'
                }
                return type
            },

            formSubmitted(event) {
                this.areFieldsDisabled = event.areFieldsDisabled
            },
        },
    }
</script>
